import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {NgbModule} from '@ng-bootstrap/ng-bootstrap';
import {AccordionAnchorDirective} from './accordion/accordionanchor.directive';
import {AccordionLinkDirective} from './accordion/accordionlink.directive';
import {AccordionDirective} from './accordion/accordion.directive';
import {HttpClient, HttpClientModule} from '@angular/common/http';

import {TitleComponent} from '../layout/admin/title/title.component';
import {CardComponent} from './card/card.component';
import {CardToggleDirective} from './card/card-toggle.directive';
import {ModalBasicComponent} from './modal-basic/modal-basic.component';
import {ModalAnimationComponent} from './modal-animation/modal-animation.component';
import {SpinnerComponent} from './spinner/spinner.component';
import {TranslateModule} from '@ngx-translate/core';
import {TranslateHttpLoader} from "@ngx-translate/http-loader";
import {MobileContainerComponent} from './mobile-container/mobile-container.component';
import {SiteEntityComponent} from './data-entry/site-entity/site-entity.component';
import {FormsModule} from "@angular/forms";
import {HeaderComponent} from "./mobileLayout/header/header.component";
import {RootMapComponent} from "./mobileLayout/root-map/root-map.component";
import {PanoramaContainerComponent} from "./mobileLayout/panorama-container/panorama-container.component";
import { NgSelectModule } from '@ng-select/ng-select';
import { TranslationTabComponent } from './components/translation-tab/translation-tab.component';
import { NgxDropzoneModule } from 'ngx-dropzone';
import { ComponentListComponent } from './components/component-list/component-list.component';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { MonumentEntityComponent } from './data-entry/monument-entity/monument-entity.component';

export function HttpLoaderFactory(http: HttpClient) {
    return new TranslateHttpLoader(http, 'assets/i18n/', '.json');
}


@NgModule({
    imports: [
        CommonModule,
        NgbModule,
        HttpClientModule,
        FormsModule,
        TranslateModule,
        NgSelectModule,
        NgxDropzoneModule,
        FontAwesomeModule
    ],
    exports: [
        NgbModule,
        AccordionAnchorDirective,
        AccordionLinkDirective,
        AccordionDirective,
        CardToggleDirective,
        HttpClientModule,
        TitleComponent,
        CardComponent,
        ModalBasicComponent,
        ModalAnimationComponent,
        MobileContainerComponent,
        SpinnerComponent,
        TranslateModule,
        SiteEntityComponent,
        HeaderComponent,
        RootMapComponent,
        PanoramaContainerComponent
    ],
    declarations: [
        AccordionAnchorDirective,
        AccordionLinkDirective,
        AccordionDirective,
        CardToggleDirective,
        TitleComponent,
        CardComponent,
        ModalBasicComponent,
        ModalAnimationComponent,
        SpinnerComponent,
        MobileContainerComponent,
        SiteEntityComponent,
        HeaderComponent,
        RootMapComponent,
        PanoramaContainerComponent,
        TranslationTabComponent,
        ComponentListComponent,
        MonumentEntityComponent
    ]
})
export class SharedModule {
}
